import { loadScript } from '@/common/utils/load-script';
import { useEffect, useState } from 'react';
import { PaymentMethodConfiguration } from '../../account/types/payment-method-configuration';
import { logger } from '~/logger/logger';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AdyenCheckout = any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AdyenCheckoutOptions = any;

type AdyenCheckoutHookPayload = {
  checkout: AdyenCheckout;
  ready: boolean;
  error?: Error;
};

async function initAdyen /** Origin key for accessing adyen */(
  adyenOriginKey: string,
  /** JS src for adyen JS injection */
  adyenJsSrc: string,
  paymentMethods: PaymentMethodConfiguration | undefined
): Promise<AdyenCheckoutOptions> {
  const src = adyenJsSrc;
  const environment = src.includes('live-us') ? 'live-us' : 'test';

  await loadScript(src);

  return {
    originKey: adyenOriginKey,
    locale: 'en-US',
    environment,
    showPayButton: false,
    paymentMethodsConfiguration: {
      card: {
        hasHolderName: true,
        holderNameRequired: true,
        enableStoreDetails: false,
        hideCVC: false,
      },
      ach: {
        billingAddressRequired: false,
      },
    },
    paymentMethodsResponse: paymentMethods,
  };
}

/**
 * Customer hook to load and initialize the AdyenCheckout object.
 */
export const useAdyenCheckout = (
  /** Origin key for accessing adyen */
  adyenOriginKey: string,
  /** JS src for adyen JS injection */
  adyenJsSrc: string,
  /** Any stored */
  paymentMethodConfiguration: PaymentMethodConfiguration | undefined
): AdyenCheckoutHookPayload => {
  const [checkout, setCheckout] = useState<AdyenCheckout>();
  const [error, setError] = useState<Error>();
  const [ready, setReady] = useState(false);
  const onConfigSuccess = (): void => {
    setReady(true);
  };

  useEffect(() => {
    initAdyen(adyenOriginKey, adyenJsSrc, paymentMethodConfiguration)
      .then((config) => {
        setCheckout(new window.AdyenCheckout({ ...config, onConfigSuccess }));
      })
      .catch((error) => {
        logger.error(`Adyen Error - ${error.message}`);
        setError(error);
      });
  }, [adyenJsSrc, adyenOriginKey, paymentMethodConfiguration]);

  return { checkout, ready, error };
};
